import Mousetrap from "mousetrap";
import { pipe } from "ramda";

const mousetrap = new Mousetrap();

mousetrap.bind(["ctrl+shift+alt+x", "mod+shift+alt+x"], () => {
  Promise.all([window.destroyMaterialDB(false), window.destroyUserDB(false)])
    .then(() => {
      console.info("reloading page...");
      window.location.reload();
    })
    .catch(error => console.error(error));

  return false;
});

export const bindShortcut = ([keys, action, preventDefault]) =>
  mousetrap.bind(keys, event => {
    action();
    return !preventDefault;
  });

export const bindShortcutDispatch =
  dispatch =>
  ([keys, actionCreator, preventDefault]) =>
    bindShortcut([keys, pipe(actionCreator, dispatch), preventDefault]);
